import * as React from "react";

function SvgInfo(props: React.SVGProps<SVGSVGElement>, svgRef?: React.Ref<SVGSVGElement>) {
  return <svg viewBox="0 0 16 16" ref={svgRef} {...props}><path d="M5.72.593a.571.571 0 01.57-.569h3.418a.571.571 0 01.57.569v3.419a.571.571 0 01-.57.569H6.29a.572.572 0 01-.57-.569zm6.838 14.814a.571.571 0 01-.569.569H4.011a.571.571 0 01-.569-.569v-1.14a.57.57 0 01.569-.569H5.72V9.139H4.011a.571.571 0 01-.569-.569V7.43a.571.571 0 01.569-.569h5.7a.571.571 0 01.57.569v6.27h1.709a.571.571 0 01.569.569v1.14z" fill="currentColor" fillRule="evenodd" /></svg>;
}

const ForwardRef = React.forwardRef(SvgInfo);
export default ForwardRef;